@if (data(); as msg) {
    Updated <category-item [category]="msg.category" />
}
 